/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type TensionInfo_viewer$ref: FragmentReference;
declare export opaque type TensionInfo_viewer$fragmentType: TensionInfo_viewer$ref;
export type TensionInfo_viewer = {|
  +id: string,
  +$refType: TensionInfo_viewer$ref,
|};
export type TensionInfo_viewer$data = TensionInfo_viewer;
export type TensionInfo_viewer$key = {
  +$data?: TensionInfo_viewer$data,
  +$fragmentRefs: TensionInfo_viewer$ref,
  ...
};
*/


const node/*: ReaderFragment*/ = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "TensionInfo_viewer",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    }
  ],
  "type": "Person",
  "abstractKey": null
};
// prettier-ignore
(node/*: any*/).hash = '33eea6cf569bcf2dd91c5e996a31b447';

module.exports = node;
